import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

import { Carousel } from '@mantine/carousel';
import { Text } from '@mantine/core';

import { TDateRange } from '@/shared/types/app.types';
import { SliderButton } from '@/shared/uikit/components/button/sliderButton';

import { getNearestDate } from '@/utils/date';

const dateItems = [
	{
		prefix: 'Сегодня • ',
		date: dayjs().format('DD MMM'),
		value: dayjs(),
	},
	{
		prefix: 'Завтра • ',
		date: dayjs().add(1, 'day').format('DD MMM'),
		value: dayjs().add(1, 'day'),
	},
].concat(
	Array.from({ length: 29 }, (_, idx) => ({
		prefix: '',
		date: dayjs()
			.add(idx + 2, 'day')
			.format('DD MMM'),
		value: dayjs().add(idx + 2, 'day'),
	})),
);

type DateSliderProps = {
	workTime: TDateRange;
	setDate: (date: TDateRange) => void;
};

export const DateSlider = ({ workTime, setDate }: DateSliderProps) => {
	const [currentTab, setCurrentTab] = useState<number>();

	const handleFilterBookings = (date: dayjs.Dayjs, idx: number) => {
		const start =
			idx === 0
				? getNearestDate(dayjs(date)).toDate()
				: date
						.set('hour', dayjs(workTime[0]).hour())
						.set('minute', dayjs(workTime[0]).minute())
						.toDate();
		const end = dayjs(start)
			.hour(dayjs(workTime[1]).hour())
			.minute(dayjs(workTime[1]).minute())
			.second(0)
			.toDate();
		setCurrentTab(idx);
		setDate([start, end]);
	};

	useEffect(() => handleFilterBookings(dateItems[0].value, 0), []);

	return (
		<Carousel
			withControls={false}
			slidesToScroll="auto"
			slideSize="auto"
			slideGap={8}
			align="start"
			w="100%"
			dragFree
			loop
		>
			{dateItems.map((el, idx) => (
				<Carousel.Slide id={idx === 0 ? 'today-slide-btn' : ''} key={el.date}>
					<SliderButton
						active={currentTab !== idx}
						onClick={() => handleFilterBookings(el.value, idx)}
					>
						<Text fw={500}>{el.prefix ? `${el.prefix}${el.date}` : el.date}</Text>
					</SliderButton>
				</Carousel.Slide>
			))}
		</Carousel>
	);
};
